import { useDataProcessingAgreement } from "@gik/api/legal";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import type { IDrawerProps } from "@gik/ui-legacy/Drawer/DrawerTypes";
import { UI } from "@gik/ui-legacy/UIManager";
import type WordpressLegal from "../../models/wordpress/WordpressLegal";
import { ErrorPageSection } from "../Error/ErrorPageSection";
import type { LegalPageProps } from "./LegalPage";
import { LegalPage } from "./LegalPage";
import { LegalSkeleton } from "./LegalSkeleton";

export function openDataProcessingAgreementSheet(props?: IDrawerProps) {
	return UI.modalSheet(() => <DataProcessingAgreement />, {
		...props,
		title: "Data Processing Agreement",
		padded: true,
	});
}

export type DataProcessingAgreementProps = {
	article?: WordpressLegal;
} & LegalPageProps;

function DataProcessingAgreementComp(props: DataProcessingAgreementProps) {
	const useFetch = () => {
		return useDataProcessingAgreement(true);
	};

	return (
		<FetchProvider<WordpressLegal[], string>
			fetch={useFetch}
			transform={(data) => data[0]?.content.rendered}
			loadingComponent={<LegalSkeleton />}
		>
			{({ transformed: text }) => <LegalPage {...props} text={text} />}
		</FetchProvider>
	);
}

export const DataProcessingAgreement = withComponentErrorBoundary(DataProcessingAgreementComp, {
	ErrorFallback: ErrorPageSection,
});

